<template>
	<div class="login-form">
		<div class="title color-black-gray1 layout-row layout-justify-center" v-if="!isManager">登入平台</div>
		<div class="title color-black-gray1 layout-row layout-justify-center" v-else>管理者及評審登入</div>
		<div class="center" v-if="!isManager">
			<!-- <a :href="fbLoginUrl" style="text-decoration:none;">
				<div class="fb-login layout-row layout-hv-center pointer color-white">
					<font-awesome-icon class="social-icon" :icon="['fab', 'facebook-f']" /> Facebook 登入
				</div>
			</a> -->
			<a :href="gLoginUrl" style="text-decoration:none;">
				<div class="google-login layout-row layout-hv-center pointer color-white">
					<font-awesome-icon class="social-icon" :icon="['fab', 'google']" /> Google 登入
				</div>
			</a>
		</div>
		<div class="layout-row layout-hv-center line-box" v-if="!isManager">
			<div class="line"></div>
			<div class="text-or color-black">或</div>
			<div class="line"></div>
		</div>
		<div class="layout-row register" v-if="!isManager">
			立刻
			<router-link class="register-link color-blue" :to="{name: 'Register'}">註冊新帳號</router-link>，加入改變世界的行列吧！
		</div>
		<div class="account-form">
			<el-form :model="account" ref="accountForm">
				<el-form-item prop="username">
					<el-input class="username" type="text" v-model="account.username" auto-complete="off" placeholder="帳號（Email 或故事帳號）" @keyup.enter.native="submitLogin">
						<font-awesome-icon slot="prefix" icon="user" />
					</el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input class="password" type="password" v-model="account.password" auto-complete="off" placeholder="密碼" @keyup.enter.native="submitLogin">
						<font-awesome-icon slot="prefix" icon="unlock-alt" />
					</el-input>
				</el-form-item>
			</el-form>
		</div>
		<div class="forget-password">
			<router-link class="color-blue" :to="{name:'ForgetPassword'}" v-if="!isManager">忘記密碼？</router-link>
		</div>
		<p style="color:gray;"><sup style="color:red;">＊</sup>孩子也可以使用「故事帳號」「組別密碼」登入挑戰平台更新故事資料喔!</p>
		<div class="login-button normal-button" @click="submitLogin">登入</div>
		<div class="error-message color-danger layout-row layout-wrap layout-justify-center">{{errorMessage}}</div>
		<div class="terms pointer color-text3" v-if="!isManager">
			<div class="text" @click="dialogVisible = true">會員服務條款</div>
		</div>

		<terms-dialog :visible.sync="dialogVisible"></terms-dialog>
	</div>
</template>

<script>
import validator from "@/libs/validator.js";
import TermsDialog from "@/components/register/TermsDialog.vue";
import { mapActions, mapState, mapMutations } from "vuex";
import API from "@/api/index.js";

export default {
	props: ["isManager"],
	data() {
		return {
			dialogVisible: false,
			account: {
				username: "",
				password: ""
			},
			errorMessage: ""
		};
	},
	computed: {
		...mapState("user", ["userInfo"]),
		token() {
			return this.$route.query.token;
		},
		fbLoginUrl: () =>
			`https://www.facebook.com/dialog/oauth?client_id=350960286328774&redirect_uri=${API.baseURL
			}/api/auth/login/facebook&scope=public_profile,email`,
		gLoginUrl: () =>
			`https://accounts.google.com/o/oauth2/auth?response_type=token&client_id=893519289683-4pue07ug0e3vt14ksgtmulrn1jl4ritt.apps.googleusercontent.com&redirect_uri=${API.baseURL
			}/api/auth/login/google&scope=https://www.googleapis.com/auth/userinfo.profile%20https://www.googleapis.com/auth/userinfo.email`
	},
	methods: {
		...mapActions("user", ["login", "thirdPartLogin", "cleanToken"]),
		...mapMutations("user", ["cleanUserInfo"]),
		async submitLogin() {
			let account = {
				account: this.account.username,
				password: this.account.password
			};
			if (this.account.username && this.account.password) {
				try {
					await this.login(account);
					this.handleRole();
				} catch (e) {
					this.errorMessage = e.message;
				}
			}
		},
		handleRole() {
			if (this.isManager) {
				if (this.userInfo.role == "admin" || this.userInfo.role == "manager" || this.userInfo.role == "editor" || this.userInfo.role == "judge") {
					this.$router.push({ name: "redirect" });
					return;
				}
			} else {
				if (this.userInfo.role == "user" || this.userInfo.role == "visitor") {
					this.$router.push({ name: "redirect" });
					return;
				}
			}
			this.errorMessage = "沒有此帳號";
			this.cleanUserInfo();
			this.cleanToken();
		}
	},
	async created() {
		if (this.token) {
			await this.thirdPartLogin(this.token);
			this.$router.push({ name: "redirect" });
		}
	},
	mounted() { },
	components: { TermsDialog }
};
</script>

<style lang='scss'>
.login-form {
	background-color: #fefcf3;
	padding: 40px 60px 25px 60px;
	font-size: 14px;
	height: 550px;
	min-width: 360px;

	.account-form {
		.el-input__prefix {
			display: flex;
			align-items: center;
		}
	}

	.title {
		font-size: 24px;
		margin-bottom: 39px;
	}

	.social-icon {
		margin-right: 10px;
	}

	.fb-login {
		width: 180px;
		padding: 6px 0;
		border-radius: 5px 0 0 5px;
		background-color: #3566b3;
	}

	.fb-login:hover {
		background-color: rgba(53, 102, 179, 0.8);
		box-shadow: -4px 4px 12px 0 rgba(202, 207, 212, 0.5);
	}

	.google-login {
		width: 180px;
		padding: 6px 0;
		border-radius: 0 5px 5px 0;
		background-color: #e9643a;
	}

	.google-login:hover {
		background-color: rgba(233, 100, 85, 0.8);
		box-shadow: 4px 4px 12px 0 rgba(202, 207, 212, 0.5);
	}

	.line-box {
		margin: 16px 0 19px 0;

		.line {
			width: 100%;
			height: 1px;
			background-color: #979797;
		}

		.text-or {
			padding: 0 10px;
		}
	}

	.register {
		justify-content: flex-end;
		margin-bottom: 22px;

		.register-link {
			padding: 0 5px;
		}
	}

	.forget-password {
		display: flex;
		justify-content: flex-end;
		margin-top: -15px;
	}

	.login-button {
		height: 40px;
		margin-top: 30px;
	}

	.error-message {
		height: 40px;
		padding: 0 30px;
		margin-top: 10px;
		margin-bottom: 10px;
		text-align: center;
	}

	.terms {
		display: flex;
		justify-content: flex-end;
		margin-left: -35px;

		.text {
			font-weight: 500;
			border-bottom: 1px solid #909399;
		}
	}
}
</style>